'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';
import { Button } from '@//components/Button';
import { DescriptionList, DescriptionListItem } from '@//components/DescriptionList';
import { Modal } from '@//components/Modal';
import { VStack } from '@//components/VStack';
import type { Locale } from '@//config/domain-locale-map';
import { useMarket } from '@//providers/MarketSettingsProvider';
import LocaleSwapper from './LocaleSwapper';

export const DeveloperTools: React.FC = () => {
  const [showDeveloperTools, setShowDeveloperTools] = useState(false);
  const market = useMarket();
  const locale = useLocale() as Locale;

  return (
    <>
      <Modal
        title="Developer tools"
        description="These tools are only visible in development mode."
        isOpen={showDeveloperTools}
        onClose={() => setShowDeveloperTools(false)}
      >
        <VStack gap={24}>
          <DescriptionList>
            <DescriptionListItem term="Market">{market}</DescriptionListItem>
            <DescriptionListItem term="Locale">{locale}</DescriptionListItem>
          </DescriptionList>
          <LocaleSwapper market={market} locale={locale} />
        </VStack>
      </Modal>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingBlockEnd: '1rem',
        }}
      >
        <Button
          onClick={() => setShowDeveloperTools(true)}
          title="Show developer tools"
          variant="outline"
          size="sm"
        >
          Developer tools
        </Button>
      </div>
    </>
  );
};
